export const appStatic = {"directory":"static"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"description","content":"클릭 한 번이면 영어 내신자료가 두둥!\n지문만 넣으면 11종 학습 자료와 30종 유형 문제가 바로 생성됩니다."},{"name":"author","content":"Edubrain"},{"name":"naver-site-verification","content":"ca355b5409f94a9bac59cf366c046edafcba2030"},{"name":"google-site-verification","content":"UI9nZAHdmXCyKAjtxNL-SF3DhycS88O8klAOnn6UdiM"},{"name":"robots","content":"index, follow"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover"},{"name":"theme-color","content":"#2297FF"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:title","property":"og:title","content":"자두 JADOO"},{"hid":"og:description","property":"og:description","content":"클릭 한 번이면 영어 내신자료가 두둥!\n지문만 넣으면 11종 학습 자료와 30종 유형 문제가 바로 생성됩니다."},{"hid":"og:url","property":"og:url","content":"https://www.letsjadoo.com"},{"hid":"og:site_name","property":"og:site_name","content":"자두 JADOO"},{"hid":"og:image","property":"og:image","content":"https://letsjadoo.com/og_jadoo.png"},{"hid":"og:image:width","property":"og:image:width","content":"512"},{"hid":"og:image:height","property":"og:image:height","content":"512"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.svg"},{"rel":"canonical","href":"https://www.letsjadoo.com/"}],"style":[],"script":[],"noscript":[],"charset":"utf-8","title":"자두 JADOO | 영어 내신자료 제작","htmlAttrs":{"lang":"ko-KR"}}

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true